<template>
     <div class="row">
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-warning">
                    <span class="info-box-icon"
                        ><i class="far fa-bookmark"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">Spouse registered</span>
                        <span class="info-box-number">{{ Number(spouseReg).toLocaleString()  }}</span>
                        <span class="progress-description"> </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-success">
                    <span class="info-box-icon"
                        ><i class="far fa-thumbs-up"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">Preventive program</span>
                        <span class="info-box-number">{{ Number(preventiveProgram).toLocaleString() }}</span>

                        <!-- <div class="progress">
                            <div class="progress-bar" style="width: 30%"></div>
                        </div> -->
                        <span class="progress-description"> </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-cyan">
                    <span class="info-box-icon"
                        ><i class="far fa-calendar-alt"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">Living support program</span>
                        <span class="info-box-number">{{ Number(lsp).toLocaleString() }}</span>

                        <!-- <div class="progress">
                            <div class="progress-bar" style="width: 30%"></div>
                        </div> -->
                        <span class="progress-description">
                            <!-- 70% Increase in 30 Days -->
                        </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
                <div class="info-box bg-danger">
                    <span class="info-box-icon"
                        ><i class="fas fa-vial"></i
                    ></span>

                    <div class="info-box-content">
                        <span class="info-box-text">PPTCT</span>
                        <span class="info-box-number">{{ Number(pptct).toLocaleString()  }}</span>

                        <!--<div class="progress">
                             <div class="progress-bar" style="width: 70%"></div>
                        </div>-->
                        <span class="progress-description">
                            <!-- 70% Increase in 30 Days -->
                        </span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                <!-- /.info-box -->
            </div>
            <!-- /.col -->
        </div>
</template>

<script>
    export default {
        name: 'spouse-indicators',
        data() {
    return {
      indicators: null,
      spouseReg: null,
      preventiveProgram: null,
      lsp: null,
      pptct: null,
      spouseRegPercentage: 0,
      preventiveProgramPercentage: 0,
      lspPercentage: 0,
      pptctPercentage: 0,
    };
  },
  methods: {
    async callNsepIndicators() {
      await axios
        .get("spouseIndicators")
        .then((response) => {
          if (response.status == 200) {
            this.indicators = response.data;
            this.spouseReg = this.indicators.SpouseReg;
            this.preventiveProgram = this.indicators.PreventiveProgram;
            this.lsp = this.indicators.LSP;
            this.pptct = this.indicators.PPTCT;

            // percentage calculation
            this.spouseRegPercentage = parseFloat(
              (parseInt(this.spouseReg) / 13500) * 100
            ).toFixed(0);
            this.preventiveProgramPercentage = parseFloat(
              (parseInt(this.preventiveProgram) / 2592) * 100
            ).toFixed(0);
            this.lspPercentage = parseFloat(
              parseFloat(this.lsp) * 100
            ).toFixed(0);
            this.pptctPercentage = parseFloat(
              (parseInt(this.pptct) / 250) * 100
            ).toFixed(0);
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
  },
  mounted() {
      this.callNsepIndicators()
  },
    }
</script>

<style lang="scss" scoped>

</style>
